import React, { useState } from 'react'
import { resetAdminOtpPassword, resetAdminPassword } from '../../../store/authAdmin/apis'
import { useSelector } from 'react-redux'

const ResetPasswordAdmin = () => {
  const userData = useSelector(state => state?.AuthAdmin?.auth?.user)
  const [mobile, setMobile] = useState(userData?.phone || '') 
  const [otpSent, setOtpSent] = useState(false)
  const [otp, setOtp] = useState('')
  const [newPassword, setNewPassword] = useState('')

  const handleSendOtp = async () => {
    if (mobile.length === 10) {
      await resetAdminOtpPassword({ phone: mobile })
      setOtpSent(true)
    } else {
      alert('Enter a valid 10-digit mobile number')
    }
  }

  const handleSubmit = async () => {
    if (!otp || !newPassword) {
      alert('Please enter OTP and new password')
      return
    }
    await resetAdminPassword({
      "otp": otp,
      "newPassword": newPassword
    })
  }

  return (
    <div className="min-h-[calc(100vh-70px)] flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-xl shadow-md p-6 space-y-6">
        <h2 className="text-2xl font-semibold text-center">Reset Password</h2>

        <div>
          <label htmlFor="mobileNumber" className="block text-sm font-medium text-gray-700">
            Mobile Number
          </label>
          <input
            id="mobileNumber" 
            type="tel"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            maxLength={10}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your mobile number"
          />
        </div>

        {!otpSent ? (
          <button
            onClick={handleSendOtp}
            className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
          >
            Send OTP
          </button>
        ) : (
          <>
            <div>
              <label htmlFor="otp" className="block text-sm font-medium text-gray-700">
                OTP
              </label>
              <input
                id="otp" 
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter OTP"
              />
            </div>

            <div>
              {/* FIX: added htmlFor */}
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">
                New Password
              </label>
              <input
                id="newPassword" // FIX: added id
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter new password"
              />
            </div>

            <button
              onClick={handleSubmit}
              className="w-full py-2 px-4 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
            >
              Submit
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default ResetPasswordAdmin